var exports = {
  "k": "x93eb46d8--33066e--container",
};

module.exports = exports;
